import { http_ccpayment__api_v2, http_ccpayment_v3 } from "./http";
import EventEmitter from "events";

class InfoApi extends EventEmitter {
  // constructor() {
  //   super();
  // }

  getUserToken(): Promise<{ token: string }> {
    return http_ccpayment__api_v2.postJson("/api/apidocToken", {
      data: {},
    });
  }

  getUserInfo(): Promise<{ detail: getUserInfoRes }> {
    return http_ccpayment_v3.postJson("/info", {
      data: {},
    });
  }

  logout(): Promise<any> {
    return http_ccpayment_v3.postJson("/logout", {
      data: {},
    });
  }
}

export interface getUserInfoRes {
  merchant_id: string;
  email: string;
  title: string;
  phone: string;
  phone_area: string;
  google_key: string;
  wwl_status: number;
  lock_unit: number;
  email_notify: number;
  safety_2fa: number;
  safety_2fa_status: number;
  micro_withdraw: number;
  webhook_notify_mode: number;
  logo: string;
  webhook_url: string;
  status: number;
  role_id: number;
  merchant_status: number;
  is_pay_passwd: boolean;
  latest_login_ip: string;
  display_id: string;
  auto_swap: number;
  username: string;
  member_num: number;
  test_coin: number;
  version: number;
  app_id: string;
  withdraw_approve: number;
  withdraw_approve_setting: WithdrawApproveSetting;
  auto_add_coin: number;
}
export interface WithdrawApproveSetting {
  limit_types: number[];
  limit_qty: string;
  ttl: number;
  expired_run_mode: number;
  safety_mode: number;
}

export default InfoApi;
